import React, { Component } from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import compose from 'lodash/fp/compose';

import API from '../../../api';
import { promiseLoader } from '../../../components/common/promise-loader';
import PreSaleForm from '../../../components/staff/pre-sale-form';

class PreSaleEdit extends Component {
  static propTypes = {
    preSale: object
  };

  render () {
    const { preSale } = this.props;
    return (
      <>
        <h2>Editar pre-venta #{preSale.id}</h2>
        <PreSaleForm action='edit' preSale={preSale}/>
      </>
    );
  }
}

export default compose(
  withRouter,
  promiseLoader(
    ({ match: { params: { id } } }) => API.staff.getPreSale(id),
    'preSale'
  )
)(PreSaleEdit);
